import { styled } from '@mui/material'
import { ItemDetails, PeopleList } from 'components'
import LocalSensitiveFunctions from 'components/Local Sensitive Functions/LocalSensitiveFunctions'
import { useApplicationOwners, useResponsibleParty } from 'hooks'
import { useIsSmallScreen } from 'packages/core'
import { useTranslation } from 'react-i18next'
import useSubcomponents from 'useSubcomponents'
import { PersonDetails } from 'components/ApplicationBanner/PersonDetails'

const PaddedDiv = styled('div')({
    padding: '0 31px',
})

const hasAccessToResponsiblePartyControl =
    'ITShop-AzureRoles-Details-ResponsibleParty-Control'

const AdditionalInformationSection = ({ rbacRole }) => {
    const { t } = useTranslation()

    const { hasAccessToLocalSensitiveFunctionsGrid, hasAccessToControl } =
        useSubcomponents()

    const attributeOrientation = useIsSmallScreen() ? 'vertical' : 'horizontal'

    const {
        data: ownersAndApprovers,
        isInitialLoading: ownersAndApproversLoading,
    } = useApplicationOwners(rbacRole?.id)

    const {
        data: responsibleParty,
        isInitialLoading: responsiblePartyLoading,
    } = useResponsibleParty(
        rbacRole?.id,
        Boolean(hasAccessToControl(hasAccessToResponsiblePartyControl)),
    )

    return (
        <>
            {ownersAndApproversLoading || responsiblePartyLoading ? (
                <ItemDetails.AttributesContainer>
                    <PaddedDiv>
                        <ItemDetails.AttributesLoader />
                    </PaddedDiv>
                </ItemDetails.AttributesContainer>
            ) : (
                <ItemDetails.AttributesContainer bottomPadding="0">
                    <PaddedDiv>
                        <ItemDetails.Attribute
                            label={t('Common_Owners')}
                            value={
                                <PeopleList
                                    list={ownersAndApprovers?.owners ?? []}
                                />
                            }
                            orientation={attributeOrientation}
                        />
                        <ItemDetails.Attribute
                            label={t('Common_Approvers')}
                            value={
                                <PeopleList
                                    list={ownersAndApprovers?.approvers ?? []}
                                />
                            }
                            orientation={attributeOrientation}
                        />
                        {hasAccessToControl(
                            hasAccessToResponsiblePartyControl,
                        ) && (
                            <ItemDetails.Attribute
                                label={t('Applications_Owner')}
                                value={
                                    responsibleParty ? (
                                        <PersonDetails
                                            size="medium"
                                            person={{
                                                imageThumbUrl:
                                                    responsibleParty.imageThumbUrl,
                                                friendlyName:
                                                    responsibleParty.friendlyName,
                                                email: responsibleParty.email,
                                                telephone:
                                                    responsibleParty.telephone,
                                            }}
                                        />
                                    ) : (
                                        <>-</>
                                    )
                                }
                                orientation={attributeOrientation}
                            />
                        )}
                    </PaddedDiv>

                    {hasAccessToLocalSensitiveFunctionsGrid && (
                        <LocalSensitiveFunctions
                            rbacRole={rbacRole}
                            protectSubcomponent={
                                hasAccessToLocalSensitiveFunctionsGrid
                            }
                        />
                    )}
                </ItemDetails.AttributesContainer>
            )}
        </>
    )
}

export default AdditionalInformationSection
